import React from 'react';
import { object, func, string } from 'prop-types';
import { getContext } from '@fiverr-private/fiverr_context';
import { Button } from '@fiverr-private/fit';
import { isLoggedInUser } from '../../../../utils/isLoggedInUser';
import { FirstMessagePopup } from '..';
import { onGuestClick, redirectToInboxConversation } from '../../../../utils/contactSeller';

const Trigger = (
    { onClick, className, children },
    { pathfinderWrapper, general, biEvents }
) => {
    const handleClick = (openModal) => {
        const { isMobile } = getContext();

        onClick();

        if (!isLoggedInUser()) {
            return onGuestClick({ biEvents, pathfinderWrapper });
        }

        isMobile? redirect() : openModal();
    };

    const redirect = () => {
        redirectToInboxConversation(pathfinderWrapper);
    };

    const buttonProps = () => ({
        className,
        color: general.isPro ? Button.COLORS.BLACK : Button.COLORS.GREY,
        fill: Button.FILLS.GHOST
    });

    return (
        <FirstMessagePopup trigger={({ open }) => (
            <Button {...buttonProps()}
                onClick={() => handleClick(open)}>
                {children}
            </Button>
        )}/>
    );
};

Trigger.propTypes = {
    onClick: func.isRequired,
    className: string,
    children: func
};

Trigger.contextTypes = {
    pathfinderWrapper: object,
    general: object,
    biEvents: object
};

export default Trigger;
